// extracted by mini-css-extract-plugin
export var actionButton = "_6i-1";
export var actionButtons = "_6i-2";
export var actions = "_6i-0";
export var aiUnread = "_6i-10";
export var alignCenter = "_6i-h";
export var backWrapper = "_6i-3";
export var cellContainer = "_6i-4";
export var checkboxContainer = "_6i-5";
export var contentContainer = "_6i-6";
export var contentHeader = "_6i-8";
export var conversationsTableWrapper = "_6i-s";
export var draftReplyBadgeContainer = "_6i-m";
export var dropdownItem = "_6i-b";
export var dropdownItemsContainer = "_6i-a";
export var dropdownTitle = "_6i-c";
export var errorIcon = "_6i-7";
export var filter = "_6i-d";
export var gray = "_6i-i";
export var headerActionButtons = "_6i-e";
export var headerCheckboxContainer = "_6i-f";
export var icon = "_6i-j";
export var menuContainer = "_6i-k";
export var noMoreTicketsIcon = "_6i-12";
export var noMoreTicketsSubText = "_6i-13";
export var oneLine = "_6i-l";
export var optionsButton = "_6i-n";
export var plus = "_6i-o";
export var portalButtonsWrapper = "_6i-g";
export var red = "_6i-p";
export var scrolledTop = "_6i-9";
export var search = "_6i-q";
export var selectedConversationsCount = "_6i-r";
export var spinner = "_6i-t";
export var strong = "_6i-u";
export var summaryCell = "_6i-v";
export var tableContainer = "_6i-11";
export var tagContainer = "_6i-w";
export var threeDots = "_6i-x";
export var twoLines = "_6i-y";
export var unread = "_6i-z";